import { render, staticRenderFns } from "./EditProductGroupModal.vue?vue&type=template&id=34b8c3d7&scoped=true"
import script from "./EditProductGroupModal.vue?vue&type=script&lang=js"
export * from "./EditProductGroupModal.vue?vue&type=script&lang=js"
import style0 from "./EditProductGroupModal.vue?vue&type=style&index=0&id=34b8c3d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b8c3d7",
  null
  
)

export default component.exports